import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { style: {"padding":"16px 16px","height":"calc(100vh - 100px)","background-color":"#080718ff","overflow-y":"scroll","padding-bottom":"30px","color":"#fff"} }
const _hoisted_2 = { class: "box p-5" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  class: "box mt-4",
  style: {"width":"100%"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { style: {"color":"#fff"} }
const _hoisted_9 = { class: "w-full flex" }
const _hoisted_10 = {
  class: "text-center w-full",
  style: {"font-size":"24px"}
}
const _hoisted_11 = {
  key: 0,
  class: "w-full flex justify-center"
}

import request from "../../common/request";
import { useRouter } from "vue-router";
import { computed, onMounted, readonly } from "vue";
import { ref, reactive, watch } from "vue";
import type { UploadProps } from "ant-design-vue";
import { v4 as uuidv4 } from "uuid";
import { message } from "ant-design-vue";
import { operateLogs } from "@/common/logs";
import { getLanguage } from "@/common/translate";
import { transformDate2, transformBeiJingDate, transformLocalDate } from "@/common/tools";

export default /*@__PURE__*/_defineComponent({
  __name: 'hardware-warning',
  setup(__props) {

const router = useRouter();
const loading = ref(false);
/** Operation log recording */
operateLogs("Access hardware alarms");
/** Operation log recording */
let language: any = ref("English");
const getLang = () => {
  language.value = localStorage.getItem("language") || "English";
};
getLang();

let dataList: any = ref([]);
const columns = [
  {
    title: getLanguage("监测类型"),
    dataIndex: "type",
    align: "center",
  },
  {
    title: getLanguage("故障模式"),
    dataIndex: "type",
    align: "center",
  },
  {
    title: getLanguage("报警内容"),
    dataIndex: "message",
    align: "center",
  },
  {
    title: getLanguage("报警时间"),
    dataIndex: "createAt",
    align: "center",
  },
  {
    title: getLanguage("报警状态"),
    dataIndex: "status",
    align: "center",
  },
];

let searchModel: any = ref({
  skip: 1,
  take: 20,
  total: 0,
  type: null,
});
const pagination = computed(() => ({
  total: searchModel.value.total,
  current: searchModel.value.skip,
  pageSize: searchModel.value.take,
}));

let typeList: any = [
  { label: "传感器", value: 7 },
  { label: "数采器", value: 6 },
];
let statusList: any = [
  { label: "未处理", value: 0 },
  { label: "已处理", value: 1 },
];

const getTypeLabel = (value: any) => {
  const item = typeList.find((p: any) => p.value === value);
  if (item?.label) return getLanguage(item.label);
  return value ? getLanguage(String(value)) : "";
};
let selectedRowKeys: any = ref();
let visible: any = ref(false);
let isEdit: any = ref(false);
let form = ref({
  remark: "",
});

onMounted(() => {
  init();
});

const init = () => {
  getData();
};

const reset = () => {
  searchModel.value.type = null;
  searchModel.value.status = null;
  searchModel.value.date = null;
};

const search = () => {
  searchModel.value.skip = 1;
  getData();
};

const getData = async () => {
  let config: any = {
    params: {
      skip: searchModel.value.skip,
      take: searchModel.value.take,
      status: searchModel.value.status,
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  if (searchModel.value.type) {
    config.params.type = [searchModel.value.type];
  } else {
    config.params.type = [6, 7];
  }

  if (searchModel.value.date && searchModel.value.date.length === 2) {
    config.params.begin = transformBeiJingDate(transformDate2(
      new Date(searchModel.value.date[0]),
      1
    ));
    config.params.end = transformBeiJingDate(transformDate2(new Date(searchModel.value.date[1]), 2));
  }

  let result = await request.get("/api/sys-alarm/messages/list", config);
  console.log("result", result);
  dataList.value = result?.data?.list || [];
  searchModel.value.total = result?.data?.count || 0;
};

const getCheckboxProps = (record: any) => ({
  disabled: record.status === 1,
});

// Checkbox selection
const onSelectChange = (ev: any) => {
  selectedRowKeys.value = ev;
};

const handleTableChange = (pagination: any, filters: any, sorter: any) => {
  // Handle pagination data
  searchModel.value.skip = pagination.current;
  searchModel.value.take = pagination.pageSize;
  getData();
};

// Process alarm
const dealWith = () => {
  isEdit.value = true;
  console.log("selectedRowKeys.value", selectedRowKeys.value);
  if (!selectedRowKeys.value?.length)
    return message.warning("请选择报警后处理!");
  form.value.remark = "";
  visible.value = true;
};

// Submit alarm processing
const submitClose = async () => {
  if (!form.value.remark) return message.warning("请填写处理备注!");
  let submit = {
    ids: selectedRowKeys.value,
    remark: form.value.remark,
  };
  let result = await request.post("/api/sys-alarm/messages/dealwith", submit);
  console.log("result", result);
  if (result?.data) {
    message.success("处理报警成功!");
    selectedRowKeys.value = [];
    visible.value = false;
    getData();
  }
};

// View processed alarms
const view = (ev: any) => {
  isEdit.value = false;
  visible.value = true;
  form.value.remark = ev.remark;
  form.value.operator = ev.operator;
  form.value.operateTime = ev.operateTime;
};

const getRowClassName = (record: any, index: any) => {
  // Set different class names based on the index
  return index % 2 === 0 ? "even-row" : "odd-row";
};

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_close_outlined = _resolveComponent("close-outlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: _unref(language) === 'English' ? _ctx.enUS : _ctx.zhCN
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_form, {
              model: _unref(searchModel),
              name: "horizontal_login",
              layout: "inline",
              autocomplete: "off"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: _unref(getLanguage)('监测类型'),
                  name: "type"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _unref(searchModel).type,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchModel).type) = $event)),
                      style: {"width":"220px"},
                      placeholder: _unref(getLanguage)('请选择')
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeList), (item, index) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: index,
                            value: item.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(getLanguage)(item.label)), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, {
                  label: _unref(getLanguage)('报警状态'),
                  name: "type"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _unref(searchModel).status,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchModel).status) = $event)),
                      style: {"width":"220px"},
                      placeholder: _unref(getLanguage)('请选择')
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statusList), (item, index) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: index,
                            value: item.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(getLanguage)(item.label)), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, {
                  label: _unref(getLanguage)('报警时间'),
                  name: "type"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_range_picker, {
                      value: _unref(searchModel).date,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchModel).date) = $event)),
                      allowClear: false
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        onClick: reset,
                        class: "btn px-5 py-1 fff cursor-pointer ml-4"
                      }, _toDisplayString(_unref(getLanguage)("重置")), 1),
                      _createElementVNode("div", {
                        onClick: search,
                        class: "btn px-5 py-1 fff cursor-pointer ml-4",
                        style: {"background-color":"#171325ff"}
                      }, _toDisplayString(_unref(getLanguage)("查询")), 1),
                      _createElementVNode("div", {
                        onClick: dealWith,
                        class: "btn px-5 py-1 fff cursor-pointer ml-4",
                        style: {"background-color":"#171325ff"}
                      }, _toDisplayString(_unref(getLanguage)("处理报警")), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_table, {
              style: {"width":"100%"},
              size: "small",
              "row-class-name": getRowClassName,
              columns: columns,
              "data-source": _unref(dataList),
              "row-selection": {
              selectedRowKeys: _unref(selectedRowKeys),
              onChange: onSelectChange,
              getCheckboxProps: getCheckboxProps,
            },
              pagination: pagination.value,
              onChange: handleTableChange,
              rowKey: "id"
            }, {
              bodyCell: _withCtx(({ column, text, record }) => [
                (column.dataIndex === 'type')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(getTypeLabel(text)), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'status')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (!text)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(getLanguage)("未处理")), 1))
                        : _createCommentVNode("", true),
                      text
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: ($event: any) => (view(record))
                          }, _toDisplayString(_unref(getLanguage)("已处理")), 9, _hoisted_7))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'createAt')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(_unref(transformLocalDate)(text)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["data-source", "row-selection", "pagination"])
          ])
        ]),
        _createVNode(_component_a_modal, {
          visible: _unref(visible),
          "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_isRef(visible) ? (visible).value = $event : visible = $event)),
          closable: false,
          footer: null,
          bodyStyle: { background: '#080718ff' },
          style: {"top":"30%"},
          width: "1200px",
          maskClosable: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                _createElementVNode("div", {
                  class: "cursor-pointer",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(visible) //@ts-ignore
 ? visible.value = false : visible = false))
                }, [
                  _createVNode(_component_close_outlined, { style: {"font-size":"20px","color":"#fff !important"} })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(getLanguage)("处理报警")), 1),
              _createVNode(_component_a_form, {
                ref: "formRef",
                name: "advanced_search",
                class: "ant-advanced-search-form",
                style: {"margin-top":"20px"},
                model: _unref(form)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, { gutter: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          (!_unref(isEdit))
                            ? (_openBlock(), _createBlock(_component_a_form_item, {
                                key: 0,
                                name: "operator",
                                label:  _unref(getLanguage)('操 作 人'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: _unref(form).operator,
                                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).operator) = $event)),
                                    readonly: ""
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }, 8, ["label"]))
                            : _createCommentVNode("", true),
                          (!_unref(isEdit))
                            ? (_openBlock(), _createBlock(_component_a_form_item, {
                                key: 1,
                                name: "operateTime",
                                label: _unref(getLanguage)('操作时间'),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: _unref(form).operateTime,
                                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).operateTime) = $event)),
                                    readonly: ""
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }, 8, ["label"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_form_item, {
                            name: "remark",
                            label: _unref(getLanguage)('处理备注'),
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_textarea, {
                                readonly: !_unref(isEdit),
                                value: _unref(form).remark,
                                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).remark) = $event)),
                                placeholder: "",
                                rows: 4
                              }, null, 8, ["readonly", "value"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              (_unref(isEdit))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", {
                      onClick: submitClose,
                      style: {"background-color":"#171325ff","padding":"5px 10px","width":"100px","font-size":"20px","text-align":"center","cursor":"pointer"}
                    }, _toDisplayString(_unref(getLanguage)("提交")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})